"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_BANNER_SKELETON = void 0;
const TOP_BANNER_SKELETON = exports.TOP_BANNER_SKELETON = 'top-banner-skeleton';
//# sourceMappingURL=constants.js.map